export const TICKET_ATTACHMENT_MAX_BYTES = 5 * 1024 * 1024;

export const TICKET_ATTACHMENT_ACCEPT =
  '.pdf,.png,.jpg,.jpeg,.gif,.doc,.docx,.xls,.xlsx,.mp4,.mpeg';

export const TICKET_ATTACHMENT_MIME = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/gif',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'video/mpeg',
  'video/mp4',
] as const;

export type TicketAttachmentRef = {
  filename: string;
  storageKey: string;
  size: number;
  type: string;
};

export function validateTicketAttachmentFile(file: File): string | null {
  if (!TICKET_ATTACHMENT_MIME.includes(file.type as (typeof TICKET_ATTACHMENT_MIME)[number])) {
    return 'This file type is not allowed.';
  }
  if (file.size < 1 || file.size > TICKET_ATTACHMENT_MAX_BYTES) {
    return 'File must be 5 MB or smaller.';
  }
  return null;
}

export async function putFileToPresignedUrl(
  uploadUrl: string,
  file: File,
  contentType: string
): Promise<void> {
  const res = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': contentType },
    body: file,
  });
  if (!res.ok) {
    throw new Error('Upload failed. Please try again.');
  }
}

export function toAttachmentRef(file: File, storageKey: string): TicketAttachmentRef {
  return {
    filename: file.name,
    storageKey,
    size: file.size,
    type: file.type,
  };
}
